import Nav from "./Nav"
import Details from "@/components/common/Details";
import NoList from "@/components/common/NoList";
import Pdf from "@/components/common/Pdf";

const loading={
    install:function(Vue){
        // Vue.component()是用来注册全局组件的
        Vue.component('Nav',Nav)
        Vue.component('Deta',Details)
        Vue.component('NoList',NoList)
        Vue.component('Pdf',Pdf)
    }  // Header'这就是后面可以使用的组件的名字，install是vue实例上默认的一个方法
}
export default loading
